import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/home',
  component: DashBoardNav,
  children: [{
    path: '/home',
    component: () => import('@/components/home/index')
  },
  {
    path: '/pivot',
    component: () => import('@/components/home/pivot.vue')
  }
  ]
}]
